import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import { Http } from "@angular/http";
@Injectable()
export class OrderIntegrationService {

  constructor(private auth: AuthenticationService, private http: Http) { }

  //-------------------------Integration Item-----------------------------------//
  Get_ItemsForOrderIntegration(model: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemsForOrderIntegration",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Send_ItemToOrderApi(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Send_ItemToOrderApi",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSellingPriceForOrderIntegration(model: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/GetSellingPriceForOrderIntegration",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_RestItemLevelForIntegration(model: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestItemLevelForIntegration",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //-------------------------Integration Item-----------------------------------//

   //-------------------------Price Import----------------------------------//
  Get_ItemsPriceForIntegration(model:any){
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemsPriceForIntegration",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Send_ItemPriceToOrderapi(model:any){
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Send_ItemPriceToOrderapi",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
//-------------------------Price Import----------------------------------//
//-------------------------Integration Info---------------------------------//
Save_IntegrationInfo(model:any){
  return this.http
    .post(
      this.auth.baseUrl + "/services/api/rest/v1/Save_IntegrationInfo",
      model,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
}

Get_RestIntegrationInfoByLocId(model:any){
  return this.http
    .post(
      this.auth.baseUrl + "/services/api/rest/v1/Get_RestIntegrationInfoByLocId",
      model,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
}
Get_RestIntegrationDetailsInfoByLocId(model:any){
  return this.http
    .post(
      this.auth.baseUrl + "/services/api/rest/v1/Get_RestIntegrationDetailsInfoByLocId",
      model,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
}
Save_IntegrationDetailsInfo(model:any){
  return this.http
    .post(
      this.auth.baseUrl + "/services/api/rest/v1/Save_IntegrationDetailsInfo",
      model,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
}

Delete_IntegrationDetailInfo(model:any){
  return this.http
  .post(
    this.auth.baseUrl + "/services/api/rest/v1/Delete_IntegrationDetailInfo",
    model,
    this.auth.getHeader()
  )
  .map(res => {
    return res.json();
  });
}
//-------------------------Integration Info----------------------------------//

}





// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/orderIntegration/orderIntegration.service.ts